import { render, staticRenderFns } from "./ScopeSection.vue?vue&type=template&id=1da148c4&scoped=true&"
import script from "./ScopeSection.vue?vue&type=script&lang=js&"
export * from "./ScopeSection.vue?vue&type=script&lang=js&"
import style0 from "./ScopeSection.vue?vue&type=style&index=0&id=1da148c4&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da148c4",
  null
  
)

export default component.exports